var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.productId === 25765)?_c('span',[_vm._v("С кэшбеком 5% при оплате картой от Альфа Банка")]):(_vm.productId === 26182)?_c('span',{staticClass:"skuratov"},[_vm._v("Интернет-магазин")]):_c('span',{domProps:{"innerHTML":_vm._s(_vm.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }